import { shouldEnableProjectEnhancementsEpic } from 'bundles/employability-common/feature-flags/learnerProfileEpicFeatureFlags';

export const useEnableProjectEnhancements = () => {
  return shouldEnableProjectEnhancementsEpic();
};
